import React, { useContext } from 'react';

export const DEFAULT_SWEEP = {
    sweepId: null,
    name: '-',
    description: null,
    prize: '-',
    status: null,
    sportType: 'racing',
    displayOrder: null,
    openDate: null,
    closeDate: null,
    roundId: null,
    consumerId: null,
    event: {
        name: null,
        startDate: null,
        metadata: null,
        winningSelections: []
    },
    dataTTLExpiry: null,
    winnerName: null,
    winnerLocation: null,
    assets: {
        heroBannerUrl: null
    }
};

export const SweepContext = React.createContext({
    sweep: DEFAULT_SWEEP
});

export const useSweep = () => useContext(SweepContext);
